import React from 'react';
import { View, Text } from '@fairygodboss/ui';
import { NotFoundSvg } from './NotFoundSvg';

export const JobNotFound = ({
    text = 'This job is no longer available.',
    subtext = 'Select another job to keep searching.',
}) => (
    <View
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
    >
        <View>
            <View display="flex" justifyContent="center">
                <NotFoundSvg />
            </View>
            <View display="block" textAlign="center" height="122px" pt="24px">
                <Text fontSize="24px" variant="bodyLg" fontWeight={700}>
                    {text}
                </Text>
                <Text variant="bodyMd">{subtext}</Text>
            </View>
        </View>
    </View>
);
